import { battleSeenKey, createSeenList } from './seenList';

/**
 * Battle segments whose opening pane the player has dismissed.
 *
 * core sends `opening.required` for the whole live window and records nothing, so show-once is the
 * client remembering, per device. Keyed by user as well: a browser can be shared.
 */
const openings = createSeenList('slot-battle-openings-seen');

export const openingSeenKey = battleSeenKey;

export const readSeenOpenings = openings.read;

/** Records the key and returns the updated list, newest first. */
export const markOpeningSeen = openings.mark;
